import { createFileRoute } from "@tanstack/react-router"
import { TenantIntegrations } from "./-components/tenant-integrations"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId/integrations",
)({
  staticData: { breadcrumb: "Integrations" },
  component: TenantIntegrationsTab,
})

function TenantIntegrationsTab() {
  const { tenantId } = Route.useParams()
  return <TenantIntegrations tenantId={tenantId} />
}
